import { useI18n } from '@/hooks/web/useI18n'
import { Layout } from '@/utils/routerHelper'

const { t } = useI18n()

const dataServiceRouter: AppRouteRecordRaw[] = [
  // 资产中心
  {
    path: '/data-service',
    component: Layout,
    name: 'dataService',
    redirect: '/data-service/api-management',
    meta: {
      icon: 'carbon:result',
      title: t('router.dataService'),
      alwaysShow: true,
      permission: ['ds']
    },
    children: [
      {
        path: 'api-management',
        name: 'ApiManagement',
        component: () => import('@/views/DataService/ApiManagement/index.vue'),
        meta: {
          icon: 'carbon:ibm-cloud-pak-business-automation',
          title: t('router.apiManagement'),
          // noCache: true, // 不缓存  ，防止添加或删除接口数据为未更新
          permission: ['ds:ama']
        },
        children: [
          {
            path: 'add-api',
            name: 'AddApi',
            component: () =>
              import('@/views/DataService/ApiManagement/components/EditApi/index.vue'),
            meta: {
              hidden: true,
              icon: 'carbon:add-large',
              title: t('router.addApi'),
              permission: ['ds:am:aa']
            }
          },
          {
            path: 'edit-api',
            name: 'EditApi',
            component: () =>
              import('@/views/DataService/ApiManagement/components/EditApi/index.vue'),
            meta: {
              hidden: true,
              icon: 'carbon:cloud-satellite',
              title: t('router.editApi'),
              noCache: true,
              permission: ['ds:am:ea']
            }
          },
          {
            path: 'detail-api',
            name: 'DetailApi',
            component: () =>
              import('@/views/DataService/ApiManagement/components/DetailApi/index.vue'),
            meta: {
              hidden: true,
              icon: 'carbon:align-box-middle-center',
              title: t('router.detailApi'),
              noCache: true,
              permission: ['ds:am:da']
            }
          }
        ]
      },
      // {
      //   path: 'api-log',
      //   name: 'ApiLog',
      //   component: () => import('@/views/DataService/ApiLog/index.vue'),
      //   meta: {
      //     icon: 'carbon:cloud-satellite',
      //     title: t('router.apiLog'),
      //     noCache: true,
      //     permission: ['ds:al']
      //   }
      // },
      // {
      //   path: 'api-monitor',
      //   name: 'ApiMonitor',
      //   component: () => import('@/views/DataService/ApiMonitor/index.vue'),
      //   meta: {
      //     icon: 'carbon:chart-line',
      //     title: t('router.apiMonitor'),
      //     noCache: true,
      //     permission: ['ds:amo']
      //   }
      // },
      {
        path: 'api-category',
        name: 'ApiCategory',
        component: () => import('@/views/DataService/ApiCategory/index.vue'),
        meta: {
          icon: 'carbon:calculator',
          title: t('router.apiCategory'),
          noCache: true,
          permission: ['ds:ac']
        }
      },
      {
        path: 'data-source',
        name: 'DataSource',
        component: () => import('@/views/DataService/DataSource/index.vue'),
        meta: {
          icon: 'carbon:api',
          title: t('router.dataSource'),
          permission: ['ds:ds']
        },
        children: [
          {
            path: 'table',
            name: 'TableSource',
            component: () => import('@/views/DataService/DataSource/TableSource/index.vue'),
            meta: {
              hidden: true,
              icon: 'carbon:api',
              title: t('router.connectTable'),
              permission: ['ds:ds']
            }
          }
        ]
      }
    ]
  }
]

export default dataServiceRouter
